import React, { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { Handshake, Plus, Wrench } from "lucide-react"
import ServicesList, { resolveServiceImageUrl } from "./ServicesList"
import AddServiceModal from "./AddServiceModal"
import useFetchServices from "../../../hooks/DataFetching/useFetchServices"

const ServicesPage = () => {
  const [showAddModal, setShowAddModal] = useState(false)
  const [selectedService, setSelectedService] = useState(null)
  const [reload, setReload] = useState(false)
  const { services, loading, error, refetch } = useFetchServices(reload)

  const handleServiceCreated = () => {
    setShowAddModal(false)
    setReload(!reload)
  }

  return (
    <main className="tyk-page">
      <div className="tyk-page-shell">
        <section className="tyk-hero-panel">
          <div>
            <span className="tyk-kicker">
              <Handshake size={16} aria-hidden="true" />
              Trusted services
            </span>
            <h1 className="tyk-hero-title">Services</h1>
            <p className="tyk-hero-copy">
              Offer skills, hire trusted members, and discover useful service listings across the TYK network.
            </p>
          </div>
          <button type="button" className="tyk-action" onClick={() => setShowAddModal(true)}>
            <Plus size={16} aria-hidden="true" />
            Add service
          </button>
        </section>

        <section className="tyk-panel">
          <div className="tyk-toolbar">
            <div>
              <span className="tyk-kicker">
                <Wrench size={15} aria-hidden="true" />
                Marketplace
              </span>
              <p className="m-0 text-sm text-slate-400">
                {services?.length || 0} service listing{services?.length === 1 ? "" : "s"} available.
              </p>
            </div>
          </div>
          <ServicesList
            services={services}
            loading={loading}
            error={error}
            onRetry={refetch}
            onServiceCardClick={setSelectedService}
          />
        </section>

        {selectedService && (
          <Modal show={!!selectedService} onHide={() => setSelectedService(null)} className="tyk-modal" centered size="lg">
            <Modal.Header closeButton closeVariant="white">
              <div>
                <span className="tyk-kicker">Service detail</span>
                <Modal.Title>{selectedService.title}</Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="grid gap-4 md:grid-cols-[220px_minmax(0,1fr)]">
                {resolveServiceImageUrl(selectedService.imageUrl) ? (
                  <img
                    src={resolveServiceImageUrl(selectedService.imageUrl)}
                    alt={selectedService.title}
                    className="h-56 w-full rounded-xl object-cover"
                  />
                ) : (
                  <div className="grid h-56 place-items-center rounded-xl border border-slate-500/20 bg-slate-950/40 text-slate-400">
                    No image
                  </div>
                )}
                <div>
                  <p className="text-base leading-7 text-slate-200">{selectedService.description}</p>
                  {selectedService.price && (
                    <div className="tyk-stat mt-4">
                      <span>Listed price</span>
                      <strong>{selectedService.price}</strong>
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setSelectedService(null)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <AddServiceModal
          show={showAddModal}
          handleClose={() => setShowAddModal(false)}
          onServiceCreated={handleServiceCreated}
        />
      </div>
    </main>
  )
}

export default ServicesPage
